import { render, staticRenderFns } from "./UpdateRequest.vue?vue&type=template&id=2caba350&scoped=true&"
import script from "./UpdateRequest.vue?vue&type=script&lang=js&"
export * from "./UpdateRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caba350",
  null
  
)

export default component.exports